import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmCloneValidFormDataType } from '../schema/types';
import { AlgorithmBasicType } from '../../schema/types';

const postAlgorithmClone = (
  algorithmClone: AlgorithmCloneValidFormDataType,
  headers?: HttpHeaders
) =>
  apiClient
    .post<AlgorithmBasicType>(
      expand(AlgorithmUrl.CLONE, {}),
      algorithmClone,
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

export const useMutateAlgorithmCloneQuery = createApiMutationHook(
  ['algorithm-clone'],
  getMutationFn(postAlgorithmClone)
);
